import { toNano } from "@ton/core";

export const TON_DEFAULT_GAS = toNano("0.05");
export const TON_MIN_COMMISSION = toNano("0.01");
export const TON_MIN_JETTON_STORAGE = toNano("0.001");

export const TON_CHAIN = {
  MAINNET: -239,
  TESTNET: -3,
};
